import React from "react";
import styled from "styled-components";
import { Colors } from "../ColorConstants";

const ToastMessage = ({ message, subMessage }) => {
  return (
    <>
      <StyledMessage>{message}</StyledMessage>
      <StyledSubMessage>{subMessage}</StyledSubMessage>
    </>
  );
};

const StyledMessage = styled.p`
  font-weight: 500;
  font-family: "Poppins-Medium";
  font-style: normal;
  font-size: 14px;
  color: ${Colors.black};
  margin: 0;
`;

const StyledSubMessage = styled.p`
  color: #acacac;
  margin: 0;
  font-family: "Poppins-Book";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  padding-top: 2px;
`;

export default ToastMessage;
